import React from 'react';
import { Card, CardContent, Typography, Box, Theme } from '@mui/material';
import CountUp from 'react-countup';

interface StatCardProps {
  label: string;
  value: number;
  iconSrc: string;
  onClick?: () => void;
  isSmallScreen: boolean;
  theme: Theme;
  stripColor?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  iconSrc,
  onClick,
  isSmallScreen,
  theme,
  stripColor = theme.palette.primary.main
}) => {
  return (
    <Card
      elevation={4}
      onClick={onClick}
      sx={{
        borderRadius: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 0.3s, box-shadow 0.3s',
        cursor: onClick ? 'pointer' : 'default',
        position: 'relative',
        overflow: 'hidden',
        '&:hover': {
          transform: 'translateX(-5px)',
          boxShadow: theme.shadows[8],
          '& .strip': {
            width: '4px'
          }
        }
      }}
    >
      <Box
        className="strip"
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '8px',
          backgroundColor: stripColor,
          transition: 'width 0.3s ease'
        }}
      />

      <CardContent
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          ml: '12px',
          py: 1,
          '&:last-child': {
            pb: 1
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img
            alt="icon"
            src={iconSrc}
            style={{
              height: isSmallScreen ? '40px' : '50px',
              width: isSmallScreen ? '40px' : '50px'
            }}
          />
          <Typography
            fontWeight={600}
            fontSize={isSmallScreen ? 14 : 16}
            noWrap
            color="primary"
            sx={{ ml: 1 }}
          >
            {label}
          </Typography>
        </Box>

        <Typography
          variant="h4"
          color="text.secondary"
          sx={{
            textAlign: 'right',
            mt: 0.5, // Reduced margin-top
            fontSize: isSmallScreen ? '1.5rem' : '2rem'
          }}
        >
          <b>
            <CountUp
              end={value}
              duration={1.5}
              separator=","
              preserveValue={true}
            />
          </b>
        </Typography>
      </CardContent>
    </Card>
  );
};

export default StatCard;














// import React from 'react';
// import { Card, CardContent, Typography, Box, Theme } from '@mui/material';
// import CountUp from 'react-countup';

// interface StatCardProps {
//   label: string;
//   value: number;
//   iconSrc: string;
//   onClick?: () => void;
//   isSmallScreen: boolean;
//   theme: Theme;
//   stripColor?: string; // Optional prop for custom strip color
// }

// const StatCard: React.FC<StatCardProps> = ({
//   label,
//   value,
//   iconSrc,
//   onClick,
//   isSmallScreen,
//   theme,
//   stripColor = theme.palette.primary.main // Default to primary color if not specified
// }) => {
//   return (
//     <Card
//       elevation={4}
//       onClick={onClick}
//       sx={{
//         borderRadius: 2,
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         transition: 'transform 0.3s, box-shadow 0.3s',
//         cursor: onClick ? 'pointer' : 'default',
//         position: 'relative',
//         overflow: 'hidden',
//         '&:hover': {
//           transform: 'translateX(-5px)',
//           boxShadow: theme.shadows[8],
//           '& .strip': {
//             width: '4px'
//           }
//         }
//       }}
//     >
//       {/* Colored strip that collapses on hover */}
//       <Box
//         className="strip"
//         sx={{
//           position: 'absolute',
//           left: 0,
//           top: 0,
//           bottom: 0,
//           width: '8px',
//           backgroundColor: stripColor,
//           transition: 'width 0.3s ease'
//         }}
//       />

//       <CardContent
//         sx={{
//           flexGrow: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'space-between',
//           ml: '12px' // Add margin to prevent content from being too close to the strip
//         }}
//       >
//         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//           <img
//             alt="icon"
//             src={iconSrc}
//             style={{
//               height: isSmallScreen ? '40px' : '50px',
//               width: isSmallScreen ? '40px' : '50px'
//             }}
//           />
//           <Typography
//             fontWeight={600}
//             fontSize={isSmallScreen ? 14 : 16}
//             noWrap
//             color="primary"
//             sx={{ ml: 1 }}
//           >
//             {label}
//           </Typography>
//         </Box>

//         <Typography
//           variant="h4"
//           color="text.secondary"
//           sx={{
//             textAlign: 'right',
//             mt: 1,
//             fontSize: isSmallScreen ? '1.5rem' : '2rem'
//           }}
//         >
//           <b>
//             <CountUp
//               end={value}
//               duration={1.5}
//               separator=","
//               preserveValue={true}
//             />
//           </b>
//         </Typography>
//       </CardContent>
//     </Card>
//   );
// };

// export default StatCard;